import { render } from "./ResultInfoCardComponent.vue?vue&type=template&id=cfa5f69e"
import script from "./ResultInfoCardComponent.vue?vue&type=script&lang=js"
export * from "./ResultInfoCardComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__